import "core-js/modules/es.function.name.js";

/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'components/UI';
import { convertToAdditionalCurrency } from 'utils';
import { modalContent, reportItem, totalAmount } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ConfirmReportModal = function ConfirmReportModal(_ref) {
  var _report$user, _report$office;

  var modalRef = _ref.modalRef,
      report = _ref.report,
      onConfirm = _ref.onConfirm,
      onClose = _ref.onClose;
  return ___EmotionJSX(Modal, {
    ref: modalRef,
    onClose: onClose
  }, report && ___EmotionJSX("div", {
    css: modalContent
  }, ___EmotionJSX("h4", {
    className: "mb1"
  }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u043E\u0442\u0447\u0435\u0442"), ___EmotionJSX("p", {
    className: "mb1"
  }, ___EmotionJSX("strong", null, "\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u043D\u0430 \u043E\u0442\u0447\u0435\u0442\u0430:")), ___EmotionJSX("div", {
    className: "mb1"
  }, ___EmotionJSX("div", {
    css: reportItem
  }, ___EmotionJSX("p", null, "ID: ", report.id), ___EmotionJSX("p", null, "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B: ", (_report$user = report.user) === null || _report$user === void 0 ? void 0 : _report$user.name), ___EmotionJSX("p", null, "\u041E\u0444\u0438\u0441: ", (_report$office = report.office) === null || _report$office === void 0 ? void 0 : _report$office.name))), ___EmotionJSX("div", {
    css: totalAmount
  }, ___EmotionJSX("p", null, ___EmotionJSX("strong", null, "\u041E\u0431\u0449\u0430 \u0441\u0443\u043C\u0430:")), ___EmotionJSX("p", null, report.total_amount, " ", report.currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
    value: report.total_amount,
    fromCurrency: report.currency
  }))), ___EmotionJSX("p", {
    className: "mb1",
    style: {
      color: '#666'
    }
  }, "\u0421\u0438\u0433\u0443\u0440\u043D\u0438 \u043B\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0438\u0442\u0435 \u0442\u043E\u0437\u0438 \u043E\u0442\u0447\u0435\u0442?"), ___EmotionJSX("div", {
    css: function css(t) {
      return t.displayFlex({
        justify: 'flex-end'
      });
    }
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return modalRef.current.close();
    },
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
    type: "success",
    onClick: onConfirm
  }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438"))));
};

ConfirmReportModal.propTypes = {
  modalRef: PropTypes.object,
  report: PropTypes.object,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func
};
export default ConfirmReportModal;